<div class="col-xs-12 col-md-12 page-heading-strip page-heading-bar no-padding dont-display">
    <div class="col-xs-3 col-lg-1 col-md-1">
        <a>
            <span class="img-span"><img class="back-arrow" src="assets/img/svg/back-arrow.svg"></span>
            <span class="back-label">BACK</span>
        </a>
    </div>
    <div class="col-xs-9 col-lg-11 col-md-11">
    </div>
</div>
<div class="container no-padding full-width border-head cboth main-fix-footer-pad">
    <section *ngIf="showLoader">
        <app-loader></app-loader>
    </section>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding flex-center-div mob-pad-10">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 left-sec no-padding dont-display">
        </div>
        <div
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 right-sec no-padding card-box-shadow top-bottom-spec-50 mob-top-bottom-spc-40">
            <div class="clearfix">
                <div class="col-xs-12 col-md-12  bottom-margin-40 pad-20">
                    <form [formGroup]="OTPForm">
                        <div class="row top-spc-20">
                            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 top-spc">
                                <div class="col-sm-6 col-md-6 col-xs-12 top-spc-20">
                                    <div id="verfyMobileNumber" class="label-text emi-otp-label">Mobile</div>
                                    <h3 class="mobile-number-lable">
                                        +91 {{mobileNumber}}
                                    </h3>
                                </div>
                                <div class="col-sm-6 col-md-6 col-xs-12 top-spc-20">
                                    <div id="verfyMobileNumber" class="label-text emi-otp-label">Amount</div>
                                    <h3 class="mobile-number-lable">Rs.
                                        {{amount ? formatter.ToCurrency(amount.toString()) : ''}}
                                    </h3>
                                </div>
                                <!-- OTP Field -->
                                <div class="form-group col-xs-10 col-md-11 col-sm-11 top-spc-20 mobileField1">
                                    <div class="input-group"
                                        [ngClass]="FormValidators.HasError(OTPForm, 'OTP','required') ? 'text-danger': FormValidators.HasError(OTPForm, 'OTP','pattern') ? 'text-danger':'' ">
                                        <input id="OTP" type="text" (keypress)="FormValidators.IsNumeric($event)"
                                            (keyup)="resendOtp = false" maxlength="6" minlength="6"
                                            class="form-control formControl" formControlName="OTP" name="OTP"
                                            autocomplete="off" required>
                                        <label class="formLabel mobileNumaber" for="OTP"
                                            [ngClass]="(OTPForm.controls['OTP'].value) ? 'atTop' : 'atBottom'">OTP
                                        </label>
                                    </div>
                                    <div class="text-danger" *ngIf="FormValidators.FieldHasErrors(OTPForm, 'OTP')">
                                        <span *ngIf="FormValidators.FieldHasSpecificError(OTPForm, 'OTP', 'required')">
                                            Please provide OTP.
                                        </span>
                                        <span *ngIf="FormValidators.FieldHasSpecificError(OTPForm, 'OTP', 'minlength')">
                                            Please provide your 6 digits OTP.
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-1 col-md-1 col-xs-2 col-sm-1 top-spc-20">

                                    <div *ngIf="!showLoader">

                                        <button id="btnprsDetailsNext" class="input-group-addon btn btn-pos verify-btn"
                                            [disabled]="!OTPForm.valid" (click)="Next()">
                                            <i class="fontIcon-39"
                                                [ngClass]="!OTPForm.valid ? 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Next' : 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Previous Rotate-180 top-margin-2'">
                                                <span class="path1"></span>
                                                <span class="path2"></span>
                                                <span class="path3"></span>
                                            </i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-12 col-sm-12">
                                    <label class="subTitle">
                                        <a id="btnResendOtp" (click)="resend()" class="text-left otp-btn-spec">Resend
                                            OTP</a>
                                    </label>
                                    <br />
                                </div>
                                <div class="col-xs-12 col-md-12 col-sm-12 verify-mobile-danger" *ngIf="resendOtp">OTP
                                    resend successfully! </div>
                                <div class="col-sm-12 col-md-12 col-xs-12 top-spc-20">
                                    <div class="guidance-text">*OTP is valid for 10 minutes.</div>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>